<template>
  <el-tag v-if="priorityName" size="medium" :type="cssClass"
  >{{ priorityName }}
  </el-tag>
</template>

<script>

  export default {
    name: "tdhvp-doc-priority-tag",
    props: ["priorityName"],
    data() {
      return {
        cssClass: ""
      }
    },

    watch: {
      priorityName() {
        this.cssClass = this.initCssClass();
      }
    },

    created() {
      this.cssClass = this.initCssClass();
    },

    methods: {
      initCssClass() {
        switch (this.priorityName) {
          case "Khẩn":
          case "Hỏa tốc":
            return "danger";
          default:
            return "";
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/thdvp/common/tdhvp-doc-priority-tag.vue